import { useEffect, useState, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';

import * as Regex from 'utils/validations';
import { DataContext } from 'providers/data';
import { FormDataPerfil, ParamsPageWebView } from 'utils/typeServices';
import { dataSex, dataCivilStatus, ParseCivilStatus } from 'core/dataPerfilQuotation';

import { Typography, Box, Collapse } from '@mui/material';

import Input from 'components/views/form/Input';
import NavTitle from 'components/views/NavTitle';
import Select from 'components/views/form/Select';
import ParseWebView from 'components/views/ParseWebView';
import { ButtonRectangle } from 'components/views/form/Button';

import { BoxFlex } from './styles';

const Perfil = ({ isWebView }: ParamsPageWebView) => {
    const { state, pathname } = useLocation();
    const [enableButton, setEnableButton] = useState(true);
    const [completedProfile, setCompletedProfile] = useState(false);
    const [showDetailsPerfil, setShowDetailsPerfil] = useState(true);
    const { register, setValue, handleSubmit, watch, formState: { errors } } = useForm<FormDataPerfil>();

    const { dataPerfilUser, selectedCar, dataCustomerForEdit, handleFormDataPerfil, handleGetPerfilUser, handleGetCustomerForEdit } = useContext(DataContext);

    const onError = (errors: Object) => {
        if (errors) {
            // SmoothScroll({ active: true, type: 'error', handlerChange: false });
        }
    }

    const onSubmit = (data: FormDataPerfil) => {
        handleFormDataPerfil({
            body: data,
            sameProfile: state?.sameProfile,
            linkNavigate: `${isWebView ? 'wb/' : ''}central-de-trocas/${pathname?.includes('troca-de-veiculo') ? 'troca-de-veiculo' : 'troca-de-servico'}/veiculo`
        });
    }

    const handleParseFormPerfil = () => {
        if (dataPerfilUser && selectedCar) {
            if (state?.exchangeVehicle || state?.sameProfile) {
                setCompletedProfile(true);
                setValue('name', dataPerfilUser.NOME_COMPLETO);
                setValue('email', dataPerfilUser.EMAIL);
                setValue('phone', '');
                ['feminino', 'masculino'].indexOf(dataPerfilUser.SEXO.toLowerCase()) >= 0 && setValue('sex', { text: dataPerfilUser.SEXO, value: dataPerfilUser.SEXO.toLowerCase() });
                setValue('identity', dataPerfilUser.DOCUMENTO);
                setValue('birthData', dataPerfilUser?.DT_NASCIMENTO || "");
                setValue('civilStatus', ParseCivilStatus(dataPerfilUser.ESTADO_CIVIL));

                if (state?.sameProfile) {
                    setValue('cep', dataPerfilUser.CEP_PERNOITE);
                    setValue('chassisOrBoard', dataPerfilUser.PLACA || selectedCar?.PLACA || selectedCar?.CHASSI);
                }
            } else {
                setValue('name', dataPerfilUser.NOME_COMPLETO);
                setValue('birthData', dataPerfilUser?.DT_NASCIMENTO || "");
                ['feminino', 'masculino'].indexOf(dataPerfilUser.SEXO.toLowerCase()) >= 0 && setValue('sex', { text: dataPerfilUser.SEXO, value: dataPerfilUser.SEXO.toLowerCase() });
                setValue('civilStatus', ParseCivilStatus(dataPerfilUser.ESTADO_CIVIL));
                setValue('identity', dataPerfilUser.DOCUMENTO);
                setValue('chassisOrBoard', dataPerfilUser.PLACA || selectedCar?.PLACA || selectedCar?.CHASSI);
            }
        } else if (selectedCar && !state?.exchangeVehicle) {
            setValue('name', selectedCar?.NOME_CLIENTE);
            setValue('identity', selectedCar.NR_CNPJ_CPF);
            setValue('chassisOrBoard', selectedCar.PLACA || selectedCar?.CHASSI);
        } else if (selectedCar) {
            setValue('name', selectedCar?.NOME_CLIENTE);
            setValue('identity', selectedCar.NR_CNPJ_CPF);
        }
    }

    const sex = watch('sex');
    const cep = watch('cep');
    const name = watch('name');
    const phone = watch('phone');
    const email = watch('email');
    const identity = watch('identity');
    const birthData = watch('birthData');
    const civilStatus = watch('civilStatus');
    const chassisOrBoard = watch('chassisOrBoard');

    const formattedCustomerBirthData = (() => {
        if (!dataCustomerForEdit?.birthDate) return '';

        const [datePart] = dataCustomerForEdit.birthDate.split('T');
        const [year, month, day] = datePart.split('-');
        const formatted = `${day}/${month}/${year}`;

        return formatted.match(Regex.birthData) ? formatted : '';
    })();

    useEffect(() => {
        if (identity && Regex.isCnpjIdentity(identity)) {
            setShowDetailsPerfil(false);
            setValue('sex', { text: '', value: '' });
            setValue('birthData', '');
            setValue('civilStatus', { text: '', value: '' });
        } else {
            setShowDetailsPerfil(true);
        }

        if (name && email && phone.match(Regex.phone) && identity && chassisOrBoard && cep) {
            if (!Regex.isCnpjIdentity(identity)) {
                if (sex?.value && birthData && civilStatus?.value) {
                    setEnableButton(false);
                }
            } else {
                setEnableButton(false);
            }
        } else {
            setEnableButton(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sex, cep, name, phone, email, identity, birthData, civilStatus, chassisOrBoard]);

    useEffect(() => {
        if (!completedProfile) {
            handleParseFormPerfil();
        }

        if (typeof dataPerfilUser === "undefined" && selectedCar) {
            handleGetPerfilUser({ token: localStorage.getItem('token')!, nrPlatform: selectedCar.NR_PLATAFORMA });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state, dataPerfilUser, selectedCar]);

    useEffect(() => {
        if (!dataCustomerForEdit) {
            handleGetCustomerForEdit({ token: localStorage.getItem('token')! });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!birthData && formattedCustomerBirthData) {
            setValue('birthData', formattedCustomerBirthData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataCustomerForEdit]);

    return (
        <ParseWebView stepActive={0} isWebView={isWebView} typePage='quotation'>
            <Box sx={{ maxWidth: '40rem', margin: '0 auto' }}>
                <Typography sx={{ fontSize: '1.25rem', paddingBottom: '1.25rem', textAlign: 'center' }}>
                    <strong>Confira</strong> os seus dados principais e complete os campos
                    indicados para prosseguimos:
                </Typography>
                <NavTitle title='Dados pessoais' />
                <Box sx={{ margin: '1.25rem auto 0', maxWidth: '26rem', 'button': { width: '100%', height: '2.5rem' } }} className='content-form' component="form" onSubmit={handleSubmit(onSubmit, onError)}>
                    <Input
                        name='name'
                        label='Nome completo'
                        placeholder='Nome'
                        type='text'
                        error={name?.match(Regex.name) ? false : true}
                        disabled={true}
                        textError="Insira nome e sobrenome"
                        register={{ ...register("name", { pattern: Regex.name }) }}
                    />
                    <Input
                        name='email'
                        label='E-mail'
                        placeholder='seuemail@email.com'
                        type='text'
                        error={email?.match(Regex.email) ? false : true}
                        disabled={completedProfile}
                        textError="Insira o e-mail corretamente"
                        register={{ ...register("email", { pattern: Regex.email }) }}
                    />
                    <BoxFlex>
                        <Input
                            name='phone'
                            label='Celular'
                            placeholder='(99) 99999-9999'
                            type='tel'
                            mask
                            error={phone?.match(Regex.phone) ? false : { type: 'pattern' }}
                            textError="Insira um número de celular"
                            register={{ ...register("phone", { pattern: Regex.phone }) }} />
                        {completedProfile ?
                            <Input
                                name='identity'
                                label='CPF ou CNPJ'
                                placeholder='999.999.999-99'
                                type='tel'
                                disabled={completedProfile}
                                textError="Insira um número válido"
                                error={identity?.match(Regex.identity) ? false : true}
                                register={{ ...register("identity", { pattern: Regex.identity }) }} />
                            :
                            <Input
                                name='identity'
                                label='CPF ou CNPJ'
                                placeholder='999.999.999-99'
                                type='tel'
                                identity
                                disabled={true}
                                textError="Insira um número válido"
                                error={identity?.match(Regex.identity) ? false : true}
                                register={{ ...register("identity", { pattern: Regex.identity }) }} />
                        }

                    </BoxFlex>
                    <Collapse in={showDetailsPerfil}>
                        <BoxFlex>
                            <Select
                                label='Sexo'
                                itemSelected={sex}
                                placeholder='Selecione'
                                listItems={dataSex}
                                disabled={(completedProfile && (dataPerfilUser && ['feminino', 'masculino'].indexOf(dataPerfilUser.SEXO.toLowerCase()) >= 0))}
                                error={sex?.value ? false : true}
                                onChangeSelected={(e) => setValue('sex', e)}
                            />
                            <Input
                                name='birthData'
                                label='Data de nascimento'
                                placeholder='10/01/1990'
                                maskHolder='99/99/9999'
                                type='tel'
                                mask
                                disabled={!!formattedCustomerBirthData}
                                error={birthData?.match(Regex.birthData) ? false : true}
                                register={{ ...register("birthData", { pattern: Regex.birthData }) }} />
                        </BoxFlex>
                    </Collapse>
                    <BoxFlex>
                        {showDetailsPerfil ?
                            <Select
                                label='Estado civil'
                                disabled={(completedProfile && (dataPerfilUser && ParseCivilStatus(dataPerfilUser.ESTADO_CIVIL).value !== ''))}
                                itemSelected={civilStatus}
                                placeholder='Seleciona'
                                listItems={dataCivilStatus}
                                error={civilStatus?.value ? false : true}
                                onChangeSelected={(e) => setValue('civilStatus', e)}
                            />
                            :
                            state?.exchangeVehicle ?
                                <Input
                                    name='chassisOrBoard'
                                    label='Placa ou chassi do novo veículo'
                                    placeholder='*aa9*99'
                                    type='text'
                                    mask
                                    identity
                                    typeIdentity='plaque'
                                    error={errors.chassisOrBoard}
                                    register={{ ...register("chassisOrBoard", { required: true }) }}
                                    uppercase
                                />
                                :
                                <Input
                                    name='chassisOrBoard'
                                    label='Placa ou chassi do carro'
                                    placeholder='*aa9*99'
                                    type='text'
                                    mask
                                    identity
                                    typeIdentity='plaque'
                                    disabled={true}
                                    error={errors.chassisOrBoard}
                                    register={{ ...register("chassisOrBoard", { required: true }) }}
                                    uppercase
                                />
                        }
                        <Input
                            name='cep'
                            label='CEP Pernoite'
                            placeholder='99999-999'
                            maskHolder='99999-999'
                            mask
                            type='tel'
                            error={cep?.match(Regex.cep) ? false : true}
                            register={{ ...register("cep", { pattern: Regex.cep }) }} />
                    </BoxFlex>
                    <Collapse in={showDetailsPerfil}>
                        {showDetailsPerfil &&
                            <Box sx={{ marginBottom: '.32rem' }}>
                                {state?.exchangeVehicle ?
                                    <Input
                                        name='chassisOrBoard'
                                        label='Placa ou chassi do novo veículo'
                                        placeholder='*aa9*99'
                                        type='text'
                                        mask
                                        identity
                                        typeIdentity='plaque'
                                        error={chassisOrBoard?.match(Regex.chassisOrBoard) ? false : true}
                                        register={{ ...register("chassisOrBoard", { required: true }) }}
                                        uppercase
                                    />
                                    :
                                    <Input
                                        name='chassisOrBoard'
                                        label='Placa ou chassi do carro'
                                        placeholder='*aa9*99'
                                        type='text'
                                        typeIdentity='plaque'
                                        disabled={true}
                                        error={errors.chassisOrBoard}
                                        register={{ ...register("chassisOrBoard", { required: true }) }}
                                        uppercase
                                    />
                                }
                            </Box>
                        }
                    </Collapse>
                    <ButtonRectangle name='Continuar' type="submit" disabled={enableButton} />
                </Box>
            </Box>
        </ParseWebView>
    );
}

export default Perfil;